<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:20:14
 * @LastEditTime: 2019-08-17 11:18:44
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
          <span>
              <el-button type="primary" @click='addStaff'>添加员工</el-button>
          </span>
          <br>
                <!-- <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
              
                    <el-form-item label="账号:">
                        <el-input v-model="mobile" clearable readonly placeholder=""></el-input>
                    </el-form-item>
                  <el-form-item label="关键词:">
                        <el-input v-model="keyWord" clearable readonly placeholder=""></el-input>
                    </el-form-item>
                    
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                    </el-form-item>
                </el-form> -->
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                    <el-table-column
                            prop="mobile"
                            label="账号"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="dealer_name"
                            label="姓名"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column
                            prop=""
                            label="上次登录时间"
                            show-overflow-tooltip>
                    </el-table-column> -->
                   <el-table-column
                            prop="msg"
                            label="备注"
                            show-overflow-tooltip>
                    </el-table-column>
              
                    <el-table-column
                            prop=""
                            label="操作"
                            width="240"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click='edit(scope.row.mobile)' >编辑</el-button>
                            <el-button type="text" size="small" @click='del(scope.row.mobile)'>删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination> -->
    </div>
</template>

<script>
    export default {
        name: "goods-onput",
        data() {
            return {
                loading:false,
                keyWord:"",
                activeName: 'first',
                form1:{
                    product_sn:'',
                    product_name:'',
                    role:'',
                    isgift:'',
                },
                form2:{
                    product_sn:'',
                    product_name:'',
                    role:'',
                    isgift:'',
                    custType:''
                },
                tableData1: [
            
                ],
           
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
           
                mobile:""
            }
        },
        methods: {
            onSearch(){
                this.$get('logistics_2','publics/Dealerpc.Dealerpc/vendorlist',{
                        customer_id:sessionStorage.getItem('customer_id'),
                        mobile:this.mobile?this.mobile:sessionStorage.getItem('mobile'),
                        keyWord:this.keyWord
                }).then(res=>{
                    this.tableData1=res.msg
                })
            },
            edit(data){
            this.$router.push({
                name:'addStaff',
                query:{edit:data}
            }) 
            },
            del(del){
                 this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(res=>{
                          this.$get('logistics_2','publics/Dealerpc.Dealerpc/deleteSon',{
                                 customer_id:sessionStorage.getItem('customer_id'),
                             mobile:this.mobile?this.mobile:sessionStorage.getItem('mobile'),
                              mobile_son:del
                          }).then(res=>{
                                this.$message({
                                    type:'success',
                                    message:"删除成功"
                                })
                                this.onSearch()
                             }).catch(error=>{
                                     this.$message({
                                    type:'error',
                                    message:"删除失败"
                                })
                             })
                    })
                  
            },
            handleClick(tab) {
            },
            handleSizeChange1(val) {
                this.pageSize = val;
                this.pageNo = 1;
                //this.getDealerList();
            },
            handleCurrentChange1(val) {
                this.pageNo = val;
                //this.getDealerList();
            },
            handleSizeChange2(val) {
                this.pageSize = val;
                this.pageNo = 1;
                //this.getGoodsList();
            },
            handleCurrentChange2(val) {
                this.pageNo = val;
                //this.getGoodsList();
                //this.getGoodsList();
            },
            addStaff(){
                this.$router.push({
                    name:'addStaff'
                })
            }
        },
        created() {
            this.onSearch()
        },
    }
</script>

<style lang="scss" scoped>
    .block{
        height: 100px;
        line-height: 24px;
        background-color: #eee;
        padding-left: 20px;
        margin-bottom: 20px;
    }

</style>